import React, { FunctionComponent } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { GenericInput } from '../../../../../components/Form/GenericInput/GenericInput';
import { onPressEnterHandlerFactory } from '../../../../../utils/formInteraction';

interface Props extends WithTranslation {
	account: string;
	blz: string;
	isValid: boolean | null;
	setAccount(iban: string): void;
	setBlz(iban: string): void;
}

const AccountNumberBLZ: FunctionComponent<Props> = (props) => {
	const accountRef = React.useRef<HTMLElement>(null);
	const blzRef = React.useRef<HTMLElement>(null);
	const formRefs = [accountRef, blzRef];

	const blurOnEnter = (event: React.KeyboardEvent) => {
		if (event.key === 'Enter') {
			(event.target as HTMLElement).blur();
		}
	};

	const onKeyPressEnter = onPressEnterHandlerFactory(formRefs, blurOnEnter);

	const setSanitizedAccount = (account: string) =>
		props.setAccount(account.slice(0, 10));

	const setSanitizedBlz = (blz: string) =>
		props.setBlz(blz.slice(0, 10).replace(/[^0-9]/g, ''));

	const accountError = () => {
		if (props.account.length > 0 && props.account.length < 10) {
			return props.t('payment.wrong_account_length');
		}

		return ibanError(props.t('payment.wrong_account_length'));
	};

	const blzError = () => {
		if (props.blz.length > 0 && props.blz.length < 8) {
			return props.t('payment.wrong_blz_length');
		}

		return ibanError(props.t('payment.wrong_blz_length'));
	};

	const ibanError = (message: string) => {
		if (props.account.length === 10 && props.blz.length === 8) {
			return props.isValid !== false ? '' : message;
		}

		return '';
	};

	const getFormattedBlz = (): string => {
		let result = props.blz;
		const blzBlocks = result.match(/.{1,3}/g);
		result = blzBlocks ? blzBlocks.join(' ') : result;

		return result;
	};

	const formattedBlz = getFormattedBlz();

	return (
		<div>
			<GenericInput
				label={props.t('payment.account_number')}
				inputId="account_number_input"
				error={accountError()}
				setInputValue={setSanitizedAccount}
				inputValue={props.account}
				type="number"
				additionalInputParams={{
					inputRef: accountRef,
					onKeyPress: onKeyPressEnter,
				}}
			/>

			<GenericInput
				label={props.t('payment.blz')}
				inputId="blz_input"
				error={blzError()}
				setInputValue={setSanitizedBlz}
				inputValue={formattedBlz}
				type="string"
				additionalInputParams={{
					inputRef: blzRef,
					onKeyPress: onKeyPressEnter,
				}}
			/>
		</div>
	);
};

export default withTranslation('translation')(AccountNumberBLZ);
